import DropdownButtonForSearch from "../Dropdowns/DropdownButtonForSearch";
import InputField from "../inputfields/InputField";
import { useEffect, useState } from "react";
import geoInfo from "../utils/geoInfo";
import otherCountry from "../utils/AllCountries";
import { searchFunction } from "../commonfunctions/searchFunction";
import * as countries from 'countries-list';

interface InputValues {
  country: string;
  province?: string;
  region?: string;
  district?: string;
  postal_code?: string;
  nationality?: string;
  city_town?: string;
}

interface CountryProps {
  inputValues: InputValues;
  errorMessage: InputValues;
  onInputChange: (id: string, value: string) => void;
  disableAll: boolean;
  editLoading: boolean;
  tabIndex: number;
  mapping: boolean;
  type: string;
  labelName: string;
  id: string;
  RequiredPostalCode?: boolean;
}
const countriesList = Object.values(countries.countries).map((country: { name: string }) => country.name);


export default function Country({ type, inputValues, onInputChange, errorMessage, labelName, id, disableAll, editLoading, tabIndex, mapping, RequiredPostalCode }: CountryProps) {
  const { country, province, region, district, postal_code, nationality, city_town } = inputValues;
  const [countries, setCountries] = useState(countriesList);
  const [provinces, setProvinces] = useState<string[]>([]);
  const [districts, setDistricts] = useState<string[]>([]);
  const [districtList, setDistrictList] = useState<string[]>([]);
  const [cities, setCities] = useState<string[]>([]);
  
  // Create provinceList from geoInfo
  const provinceList = [...new Set(geoInfo.map((item) => item.province))];
  
  const getListOfData = (
    data: { [key: string]: any }[],
    selectedValue: string,
    key: string,
    requiredKey: string
  ): string[] => {
    return Array.from(
      new Set(
        data
          .filter((item) => item[key] === selectedValue)
          .map((item) => item[requiredKey])
      )
    );
  };

  const inputFieldsConfig = {
    district: {
      labelName: "District",
      id: "district",
      tabIndex: tabIndex + 4,
      required: false,
      disabled: disableAll,
      errorMessage: errorMessage.district,
      value: district,
    },
    'City/Town': {
      labelName: "City/Town",
      id: "city_town",
      tabIndex: tabIndex + 4,
      required: false,
      disabled: disableAll,
      errorMessage: errorMessage.city_town,
      value: city_town,
    },
    // Conditionally include postal_code
    ...(!RequiredPostalCode ? {} : {
      postal_code: {
        labelName: "Postal Code",
        id: "postal_code",
        tabIndex: tabIndex + 5,
        required: true,
        disabled: disableAll,
        errorMessage: errorMessage.postal_code,
        value: postal_code,
      },
    })
  };

  const handleSearchValue = (value: string, id: string) => {
    switch (id) {
      case "country":
      case "nationality":
      case "issuer_country":
        setCountries(searchFunction(value, countriesList));
        break;
      case "province":
        setProvinces(searchFunction(value, provinceList));
        break;
      case "district":
        setDistricts(searchFunction(value, districtList));
        break;
      default:
        break;
    }
  };
  const handleInputChange = (id: string, value: string) => {
    onInputChange(id, value);
    if (id === 'nationality') {
      onInputChange(id, value);
    }
    if (id === "country" && value.toLocaleLowerCase() === "afghanistan" && country.toLocaleLowerCase() !== 'afghanistan') {
      onInputChange("province", "");
      onInputChange("region", "");
      onInputChange("district", "");
      onInputChange("city_town", "");
      onInputChange("postal_code", "");
    }
    if (country.toLocaleLowerCase() === "afghanistan") {
      switch (id) {
        case "country":
          if (country.toLocaleLowerCase() !== value.toLocaleLowerCase()) {
            onInputChange("province", "");
            onInputChange("region", "");
            onInputChange("district", "");
            onInputChange("city_town", "");
            onInputChange("postal_code", "");
          }
          let array: string[] = [...new Set(geoInfo.map((item) => item.province))]
          setProvinces(array)
          break;
        case "province":
          if (province !== value) {
            const selectedRegion = getListOfData(
              geoInfo,
              value,
              "province",
              "region_name"
            );
            onInputChange("region", selectedRegion[0]);
            const selectedDistrict = getListOfData(
              geoInfo,
              value,
              "province",
              "district"
            );
            onInputChange("postal_code", "");
            onInputChange("district", "");
            onInputChange("city_town", "");
            setDistricts(selectedDistrict);
            setDistrictList(selectedDistrict);
          }
          break;
        case "district":
          if (district !== value) {
            onInputChange("postal_code", "");
            onInputChange("city_town", "");
            const selectedCities = getListOfData(
              geoInfo,
              value,
              "district",
              "city"
            );
            // onChange('district', value)
            setCities(selectedCities);
          }
          break;
        case "city_town":
          const selectedCode = getListOfData(
            geoInfo,
            value,
            "city",
            "postal_code"
          );
          // onChange('city_town', value)
          onInputChange('postal_code', selectedCode[0].toString())
          break;
        default:
          break;
      }
    } else {
      if (id === 'country') {
        onInputChange("province", "");
        onInputChange("region", "");
        onInputChange("district", "");
        onInputChange("city_town", "");
        onInputChange("postal_code", "");
      }
      if (id === 'province') {
        const selectedRegion = getListOfData(
          otherCountry,
          value,
          "Province",
          "Region",
        );
        onInputChange("region", selectedRegion[0]);
      }
    }
  }; useEffect(() => {
    if (country.toLocaleLowerCase() === 'afghanistan') {
      let array: string[] = [...new Set(geoInfo.map((item) => item.province))]
      setProvinces(array);
    } else {
      let array: string[] = [...new Set(otherCountry.filter(item => item.Country === country).map(item => item.Province))]
      setProvinces(array);
    }
  }, [country])
  useEffect(() => {
    if (province && province !== '') {
      const selectedDistrict = getListOfData(
        geoInfo,
        province,
        "province",
        "district"
      );
      setDistricts(selectedDistrict);
    }
  }, [province]);
  const getInputs = () => {
    switch (country.toLocaleLowerCase()) {
      case "afghanistan":
        return (
          <>
            <DropdownButtonForSearch
              labelName="Province (State)"
              id="province"
              errorMessage={errorMessage.province}
              onChange={handleInputChange}
              required={true}
              tabIndex={tabIndex + 2}
              editLoading={editLoading}
              options={provinces}
              selectedValue={province}
              handleSearchValue={handleSearchValue}
              disabled={disableAll}
              modalStyle={mapping ? 'px-5 w-1/3 mb-5' : ''}
              className={mapping ? 'w-full' : ''}
            />
            <InputField
              inputItem={{
                labelName: "Region",
                id: "region",
              }}
              placeholder={country === "Afghanistan" ? 'Auto-filled based on province' : ''}
              editLoading={editLoading}
              errorMessage={errorMessage.region}
              value={region}
              required={mapping}
              disabled={true}
              tabIndex={tabIndex + 3}
              maindivstyle={mapping ? 'px-5 w-1/3 mb-5' : ''}
              className={mapping ? 'w-full' : ''}
            />
            <DropdownButtonForSearch
              labelName="District"
              id="district"
              errorMessage={errorMessage.district}
              required={true}
              tabIndex={tabIndex + 4}
              editLoading={editLoading}
              options={districts}
              disabled={!province || disableAll}
              selectedValue={district}
              onChange={handleInputChange}
              handleSearchValue={handleSearchValue}
              modalStyle={mapping ? 'px-5 w-1/3 mb-5' : ''}
              className={mapping ? 'w-full' : ''}
            />
            <DropdownButtonForSearch
              labelName="City/Town"
              id="city_town"
              errorMessage={errorMessage.city_town}
              required={true}
              tabIndex={tabIndex + 4}
              editLoading={editLoading}
              options={cities}
              disabled={!district || disableAll}
              selectedValue={city_town}
              onChange={handleInputChange}
              handleSearchValue={handleSearchValue}
              modalStyle={mapping ? 'px-5 w-1/3 mb-5' : ''}
              className={mapping ? 'w-full' : ''}
            />
            {RequiredPostalCode && <InputField
              inputItem={{
                labelName: "Postal Code",
                id: "postal_code",
              }}
              placeholder={country === "Afghanistan" ? 'Auto-filled  based on city/town' : ''}
              errorMessage={errorMessage.postal_code}
              value={postal_code}
              disabled={true}
              required={true}
              editLoading={editLoading}
              tabIndex={tabIndex + 5}
              maindivstyle={mapping ? 'px-5 w-1/3 mb-5' : ''}
              className={mapping ? 'w-full' : ''}
            />}
          </>
        );
      default:
        return (
          <>
            <DropdownButtonForSearch
              labelName="Province (State)"
              id="province"
              errorMessage={errorMessage.province}
              onChange={handleInputChange}
              required={true}
              tabIndex={tabIndex + 2}
              editLoading={editLoading}
              options={provinces}
              selectedValue={province}
              handleSearchValue={handleSearchValue}
              disabled={disableAll}
              modalStyle={mapping ? 'px-5 w-1/3 mb-5' : ''}
              className={mapping ? 'w-full' : ''}
            />
            <InputField
              inputItem={{
                labelName: "Region",
                id: "region",
              }}
              placeholder={country === "Afghanistan" ? 'Auto-filled based on province' : ''}
              editLoading={editLoading}
              errorMessage={errorMessage.region}
              value={region}
              required={mapping}
              disabled={true}
              tabIndex={tabIndex + 3}
              maindivstyle={mapping ? 'px-5 w-1/3 mb-5' : ''}
              className={mapping ? 'w-full' : ''}
            />
            {Object.entries(inputFieldsConfig).map(([key, config]) => (
              <InputField
                key={key}
                inputItem={{ labelName: config.labelName, id: config.id }}
                tabIndex={config.tabIndex}
                required={config.required}
                disabled={config.disabled}
                errorMessage={config.errorMessage}
                editLoading={editLoading}
                value={config.value}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleInputChange(config.id, event.target.value)
                }
                maindivstyle={mapping ? 'px-5 w-1/3 mb-5' : ''}
                className={mapping ? 'w-full' : ''}
              />
            ))}
          </>
        );
    }
  };
  return (
    <>
      <DropdownButtonForSearch
        labelName={labelName}
        id={id}
        errorMessage={errorMessage.country}
        onChange={handleInputChange}
        required={true}
        tabIndex={tabIndex + 1}
        editLoading={editLoading}
        options={countries}
        disabled={disableAll}
        selectedValue={id === 'country' ? country : nationality}
        handleSearchValue={handleSearchValue}
        modalStyle={mapping ? id === 'country' ? 'px-5 w-1/3' : '' : ''}
        className={mapping ? 'w-full' : ''}
      />
      {(country && type === 'country_type') && getInputs()}
    </>
  );
}
